import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@elotech/angular-common';
import { MovimentacaoPessoalPagaNaopaga } from './movimentacao-pessoal-paga-naopaga';
import { EsocialService } from '../common/services/esocial-service';

const RESOURCE = '/api/movimentacoes-pessoal';

@Injectable()
export class MovimentacaoPessoalService extends EsocialService<any> {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = RESOURCE;
  }

  public delete(movimentacaoPessoalId: number): Observable<any> {

    const request = {
      resource: `${this.resource}/notification/${movimentacaoPessoalId}`
    };

    return this.httpClient.del(request);
  }

  public podeExcluir(movimentacaoPessoalId: number): Observable<boolean> {

    const request = {
      resource: `${this.resource}/pode-excluir/${movimentacaoPessoalId}`
    };

    return this.httpClient.get(request);
  }

  public movimentacaoCalculadaComPagamento(movPessoalId: number): Observable<MovimentacaoPessoalPagaNaopaga> {
    return this.httpClient.get({
      resource: `${this.resource}/movimentacao-calculada-com-pagamento/${movPessoalId}`,
      disableSpinner: true
    });
  }

  public load(movimentacaoPessoalId: number): Observable<any> {

    const request = {
      resource: `${this.resource}/especifica/${movimentacaoPessoalId}`
    };

    return this.httpClient.get(request);
  }


  findForResumo(id: any) {
    return this.httpClient.get({
      resource: `${this.resource}/resumo/${id}`
    });
  }

  public findEventosByFuncionarioAndDataInicialAndDataFinal(idFuncionario: number, dataInicial: string,
                                                            dataFinal?: string): Observable<any> {

    let parametros = `?funcionario=${idFuncionario}&dataInicial=${dataInicial}`;

    if (dataFinal) {
      parametros = parametros.concat(`&dataFinal${dataFinal}`);
    }

    return this.httpClient.get({
      resource: `${this.resource}/proventos-por-funcionario${parametros}`,
      disableSpinner: true
    });

  }

  public existsMovimentacao12and38ComDataPosterior(matricula: number, idMovimentacao: number,
                                                   idTipoMovimentacao: number): Observable<boolean> {

    const parametros = `?matricula=${matricula}&movimentacaoId=${idMovimentacao}&tipoMovimentacaoId=${idTipoMovimentacao}`;

    return this.httpClient.get({
      resource: `${this.resource}/existe-mov-12-38-posterior${parametros}`,
      disableSpinner: false
    });
  }

  public findMovimentacaoDesligamento(idFuncionario: number, idTipoMovimentacao): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/movimentacao-by-tipo?funcionarioId=${idFuncionario}&tipoMovimentacaoId=${idTipoMovimentacao}`,
      disableSpinner: true
    });
  }

  public existsByFuncionarioIdAndTipoMovimentacaoId(idFuncionario: number, idTipoMovimentacao: number): Observable<boolean> {
    return this.httpClient.get({
      resource: `${this.resource}/exists-by/${idFuncionario}/${idTipoMovimentacao}`,
      disableSpinner: true
    });
  }

  isDataInicialCompetenciaFechada(dataInicial: string): Observable<boolean> {
    return this.httpClient.get({
      resource: `${this.resource}/is-data-inicial-competencia-fechada/?dataInicial=${dataInicial}`,
      disableSpinner: true
    });
  }

}
